var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75705 6.73943C8.61712 6.46543 9.28317 6.51653 8.9545 8.46804C8.9545 8.46804 8.59026 10.1591 8.46593 10.8295C8.3416 11.4998 9.78731 11.1494 9.78731 11.1494C9.78731 11.1494 8.97341 11.9668 8.11946 12.2162C7.26552 12.4656 6.65997 12.1547 6.93481 10.5506C6.93481 10.5506 7.37371 8.40205 7.42231 7.90223C7.47092 7.4024 6.21275 7.90223 6.21275 7.90223C6.21275 7.90223 6.89698 7.01344 7.75705 6.73943Z",
    fill: "#FF8059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03676 5.94395C8.65789 5.94395 9.16142 5.44042 9.16142 4.81929C9.16142 4.19817 8.65789 3.69464 8.03676 3.69464C7.41563 3.69464 6.91211 4.19817 6.91211 4.81929C6.91211 5.44042 7.41563 5.94395 8.03676 5.94395Z",
    fill: "#FF8059"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5Z",
    fill: "#FF8059"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.ef1eeb7c1c51d850c2b031dec5ea6b62.svg";
export { ForwardRef as ReactComponent };